import { doesNotHaveExpand, get } from "@insite/client-framework/Services/ApiService";
import { GetOrderApiParameter, GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { OrderCollectionModel, OrderModel } from "@insite/client-framework/Types/ApiModels";

const ordersUrl = "/api/v1/orders";

export async function getOrders(parameter: GetOrdersApiParameter): Promise<OrderCollectionModel> {
    const params = parameter;
    // can't send empty status array to API
    if (parameter.status && parameter.status.length === 0) {
        delete parameter.status;
    }

    if (parameter.orderNumber?.startsWith("*")) {
        params.orderNumber = parameter.orderNumber?.replace(/\*/g, "STAR");
    }
    delete (parameter as any).onComplete;
    const orders = await get<OrderCollectionModel>(ordersUrl, params);
    orders.orders?.forEach(o => {
        cleanOrder(o);
    });
    return orders;
}

export async function getOrder(parameter: GetOrderApiParameter): Promise<OrderModel> {
    const orderNumber = parameter.orderNumber.replace(/\*/g, "STAR");

    // @ts-ignore
    delete parameter.orderNumber;

    const order = await get<OrderModel>(`${ordersUrl}/${orderNumber}`, parameter);
    cleanOrder(order, parameter);
    return order;
}

function cleanOrder(orderModel: OrderModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    orderModel.orderDate = new Date(orderModel.orderDate);
    orderModel.id = orderModel.erpOrderNumber || orderModel.webOrderNumber;
    if (doesNotHaveExpand(parameter, "orderLines")) {
        delete orderModel.orderLines;
    }
}
